import { cn } from '~/lib/cn';

export const BASE_LINK_ITEM_CLASSES = cn(
  'flex',
  'justify-between',
  'rounded-sm',
  'border',
  'bg-emphasis-default',
  'border-emphasis-subtle',
  'group',
  'transition',
  'duration-300',
  'hover:bg-default-inverse/subtle',
  'hover:border-primary-default',
  'focus:border-opacity-stronger',
  'focus:bg-default-inverse/subtle',
  'focus:border-white',
);

export const PERFORMANCE_DASHBOARD_LINK_URL = '/marketing/campaigns';
export const ANOMALY_DASHBOARD_LINK_URL = '/marketing/anomaly';
